import { Hub } from "aws-amplify";
import { HubChannels } from "./hub-channels";
import { HubEvent } from "src/app/core/hub/hub-events";

export type HubCallback = (capsule: {
  channel: string;
  payload: { event: HubEvent; data?: any };
}) => void;

export function hubPublish(channel: HubChannels, event: any): void {
  Hub.dispatch(`Snoots::${channel}`, event);
}

export function hubListen(
  channel: HubChannels,
  callback: HubCallback
): HubCallback {
  Hub.listen(`Snoots::${channel}`, <any>callback);
  return callback;
}

export function hubRemove(
  channel: HubChannels,
  callback: (event: any) => void
): void {
  Hub.remove(`Snoots::${channel}`, callback);
}
